var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"re-button",class:[`re-button--${_vm.type}`, {
  'is-plain': _vm.plain,
  'is-round': _vm.round,
  'is-circle': _vm.circle,
  'is-disabled': _vm.disabled
  }],attrs:{"disabled":_vm.disabled},on:{"click":_vm.handleClick}},[(_vm.icon)?_c('i',{class:_vm.icon}):_vm._e(),(_vm.$slots.default)?_c('span',[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }